/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';

const DeceptionTellList = ({ tells }) => (
  <div className="deception-tell-list">
    {
      tells.map(({ imgSrc, tellLabel, tellKey }, index) => (
        <div
          key={tellKey}
          className={`tell-sign tell-sign-${index % 2 ? 'right' : 'left'}`}
        >
          <div className="tell-image-container">
            <img src={imgSrc} alt={tellLabel} />
          </div>
          <hr />
          <div className="tell-name">{tellLabel}</div>
        </div>
      ))
    }
  </div>
);

const tellPropType = PropTypes.shape({
  imgSrc: PropTypes.string.isRequired,
  tellLabel: PropTypes.string.isRequired,
  tellKey: PropTypes.string.isRequired,
});

DeceptionTellList.propTypes = {
  tells: PropTypes.arrayOf(tellPropType).isRequired,
};

export default DeceptionTellList;
